var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHumanitarian = function SvgHumanitarian(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34791_3703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 21.2857C17.1285 21.2857 21.2858 17.1284 21.2858 12C21.2858 6.87165 17.1285 2.71429 12.0001 2.71429C6.87171 2.71429 2.71436 6.87165 2.71436 12C2.71436 17.1284 6.87171 21.2857 12.0001 21.2857Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42871 15.5714H5.92871C6.59175 15.5714 7.22764 15.308 7.69648 14.8392C8.16533 14.3704 8.42871 13.7345 8.42871 13.0714V10.9286C8.42871 10.2655 8.6921 9.62966 9.16094 9.16082C9.62978 8.69198 10.2657 8.42859 10.9287 8.42859C11.5918 8.42859 12.2276 8.16519 12.6965 7.69635C13.1653 7.22752 13.4287 6.59163 13.4287 5.92859V2.8143",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2859 11.8572C20.5706 11.486 19.7774 11.2902 18.9716 11.2857H15.9287C15.2657 11.2857 14.6298 11.5491 14.1609 12.018C13.6921 12.4868 13.4287 13.1227 13.4287 13.7857C13.4287 14.4488 13.6921 15.0847 14.1609 15.5535C14.6298 16.0224 15.2657 16.2857 15.9287 16.2857C16.4023 16.2857 16.8566 16.4739 17.1914 16.8087C17.5263 17.1436 17.7144 17.5979 17.7144 18.0715V19.3143",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34791_3703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHumanitarian);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "humanitarian.7311bddf739466c840201d3a50d87155.svg";